import request from '../utils/Request';
import { Methods } from '../config';

const navOnlineService = {
  manuallyAcceptInvoice: (documentTypeId, documentId, data) =>
    request({ method: Methods.POST,
      resource: `nav-online/invoice/${encodeURIComponent(documentTypeId)}/${encodeURIComponent(documentId)}/manual-acceptance`, data }),
  retryInvoice: (documentTypeId, documentId, communicationId) =>
    request({ method: Methods.POST,
      resource: `nav-online/invoice/${encodeURIComponent(documentTypeId)}/${encodeURIComponent(documentId)}/retry`,
      data: { expectedCommunicationId: communicationId } }),
  getNotificationRecipients: (signal) =>
    request({ method: Methods.GET, resource: 'nav-online/config/notification-recipients', signal }),
  saveNotificationRecipients: (emails) =>
    request({ method: Methods.PUT, resource: 'nav-online/config/notification-recipients', data: { emails } }),
  getConfiguration: (signal) =>
    request({ method: Methods.GET, resource: 'nav-online/config', signal }),
  saveConfiguration: (data) =>
    request({ method: Methods.PUT, resource: 'nav-online/config', data }),
  testConnection: () =>
    request({ method: Methods.POST, resource: 'nav-online/config/test-connection' }),
  getInvoiceHistory: (documentTypeId, documentId, signal) =>
    request({
      method: Methods.GET,
      resource: `nav-online/invoice/${encodeURIComponent(documentTypeId)}/${encodeURIComponent(documentId)}/history`,
      signal,
    }),
};

export default navOnlineService;
